export default __webpack_public_path__ + "static/media/parking-moto.13e52e6e.svg";